module.exports = __webpack_public_path__ + "static/media/platform_logo_full.ed1b710c.png";